export interface Page {
  id: number | string
  description: string
  path: string
  title: string
  slug: string
  pageRoute: string
  enabled: boolean
  sidebarItem: boolean
  layoutType: PageType
  layoutStructure: any
  businessId: string | number
  metaData?: Record<string, any>
  owner?: Record<string, any>
  position: number
  settings?: Record<string, any>
  updatedAt: string
  status: PageStatus
  reportHierarchyId?: number
}

export interface PageTreeItem extends Page {
  children?: PageTreeItem[]
}

export const enum PageType {
  PAGE = 'page',
  STATIC_PAGE = 'static_page',
  UNREGISTERED = 'unregistered',
  PAGE_GROUP = 'page_group',
  COLLECTION = 'collection',
  INTERNAL = 'internal'
}

export const isClientPage = (page: Page): boolean =>
  _.includes([PageType.STATIC_PAGE, PageType.PAGE], page.layoutType) && isActive(page)

export const isInternalPage = (itemType: string | undefined): boolean =>
  itemType === PageType.INTERNAL
export const isStaticPage = (itemType: string | undefined): boolean =>
  itemType === PageType.STATIC_PAGE
export const isDynamicPage = (itemType: string | undefined): boolean => itemType === PageType.PAGE
export const isPageGroup = (itemType: string | undefined): boolean =>
  itemType === PageType.PAGE_GROUP
export const isCollection = (itemType: string | undefined): boolean =>
  itemType === PageType.COLLECTION
export const isUnregisteredPage = (itemType: string | undefined): boolean =>
  itemType === PageType.UNREGISTERED

export enum PageStatus {
  draft = 'draft',
  published = 'published'
}

export const isBrowsablePage = (page: Page): boolean =>
  _.includes([PageType.STATIC_PAGE, PageType.PAGE, PageType.INTERNAL], page.layoutType)

export const isActive = (page: Page): boolean =>
  page.enabled && _.isEqual(page.status, PageStatus.published)
export const isSidebarItem = (page: Page): boolean => page.sidebarItem && isActive(page)

export const PAGE_DISABLED_COLOR = 'bg-muted'
export const PAGE_DRAFT_COLOR = 'bg-primary-lighter'
export const PAGE_PUBLISHED_COLOR = 'bg-white'
